import { Flex } from 'app/components/design-system-components'
import { FilterDropdown } from 'app/components/design-system-components/list-filters/FilterDropdown'
import { FilterSingleDate } from 'app/components/design-system-components/list-filters/FilterSingleDate'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import {
  buildRenderedFilterConfig,
  filtersIds,
  ManagersFilterWarning,
  PodsFilterWarning,
} from 'app/sm/manager_viewings/ManagerViewingsFilters/filters.config'

const defaultTriggerProps = {
  mr: theme.space[3] + 'px',
  mb: theme.space[3] + 'px',
}

export const ManagerViewingsFilters = ({
  filters,
  updateFilter,
  managers,
  pods,
  viewingSortOptions,
  applicationSortOptions,
  disableSearchManager,
  disableDatePicker,
  disableSearchStatus,
  includePodsFilter,
  includeFilterRelets,
  isPodsDisabled = false,
  ...containerProps
}: any) => {
  const {
    [filtersIds.manager]: managerFilterConfig,
    [filtersIds.pods]: podsFilterConfig,
    [filtersIds.workflow]: workflowFilterConfig,
    [filtersIds.sort]: sortFilterConfig,
    [filtersIds.date]: dateFilterConfig,
    [filtersIds.mgmtType]: mgmtTypeFilterConfig,
  } = buildRenderedFilterConfig(filters, updateFilter)

  const onDateManualUpdate = (date: any) => {
    dateFilterConfig?.setFilterValues({
      [filtersIds.date]: date,
    })
  }

  const { manager: selectedManagers, pods: selectedPods } = filters
  const isManagerFiltered =
    Object.keys(selectedManagers?.manager || {}).length > 0
  const isPodsFiltered = Object.keys(selectedPods?.pods || {}).length > 0

  const discardFilter = (filterID: string) => {
    return () => updateFilter(filterID, {})
  }

  return (
    <Flex flexWrap="wrap" mt={theme.space[3] + 'px'} {...containerProps}>
      {!disableSearchManager && (
        <FilterDropdown
          filterConfig={managerFilterConfig}
          filterBodyProps={{ managers }}
          triggerCmpProps={defaultTriggerProps}
          requireConfirmationModal={isPodsFiltered}
          confirmationModalText={ManagersFilterWarning}
          confirmAction={discardFilter('pods')}
        />
      )}
      {includePodsFilter && (
        <FilterDropdown
          filterConfig={podsFilterConfig}
          filterBodyProps={{ pods, disabled: isPodsDisabled }}
          triggerCmpProps={defaultTriggerProps}
          requireConfirmationModal={isManagerFiltered}
          confirmationModalText={PodsFilterWarning}
          confirmAction={discardFilter('manager')}
        />
      )}
      {!disableSearchStatus && (
        <FilterDropdown
          filterConfig={workflowFilterConfig}
          triggerCmpProps={defaultTriggerProps}
          filterBodyProps={undefined}
          requireConfirmationModal={undefined}
          confirmationModalText={undefined}
          confirmAction={undefined}
        />
      )}
      {viewingSortOptions && (
        <FilterDropdown
          filterConfig={sortFilterConfig}
          filterBodyProps={{ sortOptions: viewingSortOptions }}
          triggerCmpProps={defaultTriggerProps}
          requireConfirmationModal={undefined}
          confirmationModalText={undefined}
          confirmAction={undefined}
        />
      )}
      {applicationSortOptions && (
        <FilterDropdown
          filterConfig={sortFilterConfig}
          filterBodyProps={{ sortOptions: applicationSortOptions }}
          triggerCmpProps={defaultTriggerProps}
          requireConfirmationModal={undefined}
          confirmationModalText={undefined}
          confirmAction={undefined}
        />
      )}
      {!disableDatePicker && (
        <FilterSingleDate
          onChange={onDateManualUpdate}
          filterConfig={dateFilterConfig}
          dropDownWidth="175px"
          dropDownHeight="32px"
        />
      )}
      {mgmtTypeFilterConfig && includeFilterRelets && (
        <FilterDropdown
          filterConfig={mgmtTypeFilterConfig}
          triggerCmpProps={defaultTriggerProps}
          filterBodyProps={undefined}
          requireConfirmationModal={undefined}
          confirmationModalText={undefined}
          confirmAction={undefined}
        />
      )}
    </Flex>
  )
}
